module.exports = require('./helpers/bundle-url').getBundleURL('jAKT5') + "logo-dark.eefe0b7f.svg";